import React from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  ...props
}: InputProps) {
  return <div className={`w-full ${className}`} data-id="element-24">
      {label && <label className="block text-sm font-medium text-gray-300 mb-1.5" data-id="element-25">
          {label}
        </label>}
      <div className="relative" data-id="element-26">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500" data-id="element-27">
            {icon}
          </div>}
        <input className={`
            w-full bg-navy-light border border-navy-lighter rounded-lg 
            text-white placeholder-gray-500 text-sm
            focus:outline-none focus:border-amber focus:ring-1 focus:ring-amber
            transition-colors
            ${icon ? 'pl-10' : 'px-3'} py-2.5
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-28" />
      </div>
      {error && <p className="mt-1.5 text-sm text-red-400" data-id="element-29">{error}</p>}
    </div>;
}